<div class="flex flex-col gap-y-4 overflow-hidden px-0 lg:px-10">
  <div class="flex w-full flex-col lg:flex-row lg:items-center items-start gap-4 lg:px-0 px-6 pt-4">
    <button class="button-general w-40" matButton (click)="back()">
      <div class="flex justify-center items-center gap-4">
        <span class="material-symbols-outlined"> reply </span>
        {{ 'common.actions.back' | translate }}
      </div>
    </button>

    <div class="font-semibold text-xl text-(--color-text-primary)">
      {{ 'locations.detail.title' | translate }} {{ locationDetail?.Id || '-' }}
    </div>
  </div>

  @if (locationDetail) {
    <div class="flex-col flex scrol-general-y p-6 gap-y-4">
      <div class="flex gap-4 flex-col">
        <div class="shadow-lg/30 rounded-4xl p-4 bg-white! bg-[linear-gradient(to_top,#fff,#fff)]!">
          <div class="text-(--color-text-primary) font-semibold text-xl pb-4">
            {{ 'locations.detail.sections.connectionPoints' | translate }}: {{ locationDetail.Id }}
          </div>
          <div
            class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 font-semibold text-(--color-text-primary)! /* === MÓVIL (1 columna) === */ /* Se redondea todo */ [&>div>div:first-child]:rounded-xl /* === LG (2 columnas) === */ /* Resetea el general y aplica a 1 y 2 */ lg:[&>div>div:first-child]:rounded-none lg:[&>div:nth-child(2n+1)>div:first-child]:rounded-l-xl lg:[&>div:nth-child(2n)>div:first-child]:rounded-r-xl lg:[&>div:last-child>div:first-child]:rounded-r-xl /* === XL (3 columnas) === */ /* 1. Apaga la matemática de LG (2 columnas) */ xl:[&>div:nth-child(2n+1)>div:first-child]:rounded-none xl:[&>div:nth-child(2n)>div:first-child]:rounded-none /* 2. Aplica la matemática de XL (3 columnas) */ xl:[&>div:nth-child(3n+1)>div:first-child]:rounded-l-xl xl:[&>div:nth-child(3n)>div:first-child]:rounded-r-xl xl:[&>div:last-child>div:first-child]:rounded-r-xl /* === 2XL (4 columnas) === */ /* 1. Apaga la matemática de XL (3 columnas) */ 2xl:[&>div:nth-child(3n+1)>div:first-child]:rounded-none 2xl:[&>div:nth-child(3n)>div:first-child]:rounded-none /* 2. Aplica la matemática de 2XL (4 columnas) */ 2xl:[&>div:nth-child(4n+1)>div:first-child]:rounded-l-xl 2xl:[&>div:nth-child(4n)>div:first-child]:rounded-r-xl 2xl:[&>div:last-child>div:first-child]:rounded-r-xl"
          >
            <!-- Ubicación -->
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.id' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Key || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.description' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Description || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.address' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Address || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.exteriorNumber' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.StreetNumber || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.interiorNumber' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.StreetName || '-' }}
              </div>
            </div>
            <!-- <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">Teléfono</div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.PhoneNumber || '-' }}
              </div>
            </div> -->
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.postalCode' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.PostalCode || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.neighborhood' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Locality || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.city' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.City || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.state' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.State || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.zone' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Country || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.latitude' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Latitude || '-' }}
              </div>
            </div>
            <div class="text-sm flex flex-col">
              <div class="bg-(--RJ-secundario-light) pl-2 min-h-10 flex items-center">
                {{ 'locations.detail.fields.longitude' | translate }}
              </div>
              <div class="min-h-10 flex items-center pl-2 font-medium">
                {{ locationDetail.Longitude || '-' }}
              </div>
            </div>
          </div>
        </div>

        <div class="shadow-lg/30 rounded-4xl p-4 bg-white! bg-[linear-gradient(to_top,#fff,#fff)]!">
          <div class="text-(--color-text-primary) font-semibold text-xl pb-4">
            {{ 'locations.detail.sections.editableFields' | translate }}
          </div>

          <!-- Punto de contacto -->

          <app-table-general-simple
            [headers]="headersField"
            [dataSource]="dataSourceField"
            [buttonEvent]="false"
          ></app-table-general-simple>
        </div>

        <div class="shadow-lg/30 rounded-4xl p-4 bg-white! bg-[linear-gradient(to_top,#fff,#fff)]!">
          <div class="text-(--color-text-primary) font-semibold text-xl pb-4">
            {{ 'locations.detail.sections.installedUnits' | translate }}
          </div>
          <app-table-general
            [headers]="installedUnitsHeaders"
            [dataSource]="installedUnitsDataSource"
            [buttonEvent]="false"
          ></app-table-general>
        </div>

        <div class="shadow-lg/30 rounded-4xl p-4 bg-white! bg-[linear-gradient(to_top,#fff,#fff)]!">
          <div class="text-(--color-text-primary) font-semibold text-xl pb-4">
            {{ 'locations.detail.sections.ticketsByConnectionPoint' | translate }}
          </div>
          <app-table-general
            [headers]="ticketsHeaders"
            [dataSource]="ticketsDataSource"
            [buttonEvent]="false"
          ></app-table-general>
        </div>
      </div>
    </div>
  }
</div>
<app-load-general [load]="loadService"></app-load-general>
